/* eslint-disable max-lines,*/
// todo(eran): will refactor at https://jira.wixpress.com/browse/EE-25400 */

import {createExpressCheckoutButtonsController} from '@wix/ecom-platform-express-checkout-buttons';
import {
  CheckoutStageWithCartParams,
  CurrentPrice,
  HandleCashierPaymentSubmitResult,
  IBreakdownParams,
  IMediaItem,
  InfoSectionEvent,
  IProductDTO,
  IProductPageControllerConfig,
  IPropsInjectedByViewerScript,
  ISiteSettingsCurrencies,
  ProductPagePagination,
  ProdudctQunatityRange,
  SocialSharingEvent,
  StockIndicatorCount,
  TranslationDictionary,
  UserInput,
  UserInputData,
  UserInputErrors,
} from '../types/app-types';
import {IControllerFactoryConfig} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/createViewerScript';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {getTranslations, isWorker} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/utils';
import {
  AddToCartActionStatus,
  BI_APP_NAME,
  BiInventoryStatus,
  COMPONENTS_ADD_TO_CART_TEXT_KEYS,
  COMPONENTS_BACK_IN_STOCK_TEXT_KEYS,
  COMPONENTS_OUT_OF_STOCK_TEXT_KEYS,
  COMPONENTS_PRE_ORDER_BUY_NOW_TEXT_KEYS,
  COMPONENTS_PRE_ORDER_TEXT_KEYS,
  ErrorTooltipPlacement,
  InfoSectionLayoutId,
  Layout,
  LayoutId,
  LayoutNames,
  ModalState,
  MULTILINGUAL_TO_TRANSLATIONS_MAP,
  Origin,
  PaymentOptionsBreakdownTheme,
  PaymentOptionsBreakdownThemeValue,
  PRODUCT_PAGE_APP_NAME,
  ProductOptionType,
  productPageFedopsEvent,
  ProductPageSlotIds,
  ProductType,
  QUICK_VIEW_APP_NAME,
  ReviewsSlotIds,
  SocialVendor,
  STORES_NAMESPACE,
  translationPath,
  UserInputType,
} from '../constants';
import {ProductService} from '../services/ProductService';
import {QuantityCalculator} from '@wix/wixstores-client-core/dist/es/src/quantity-calculator/quantityCalculator';
import {
  actualPrice,
  actualSku,
  hasSubscriptionPlans,
  inStock,
  isPreOrder,
  userInputsFactory,
} from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
import _ from 'lodash';
import {
  ActionStatus,
  AddToCartActionOption,
  APP_DEFINITION_ID,
  BiButtonActionType,
  PageMap,
  PubSubEvents,
  StoresWidgetID,
} from '@wix/wixstores-client-core/dist/es/src/constants';
import {MultilingualService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/MultilingualService/MultilingualService';
import {IAppSettings, IProductOptionSelection} from '@wix/wixstores-graphql-schema/dist/es/src/graphql-schema';
import {parseUrl} from '@wix/native-components-infra/dist/src/urlUtils';
import {IStoreFrontNavigationContext} from '@wix/wixstores-client-core/dist/src/types/site-map';
import {
  clickOnProductDetailsSfParams,
  socialButtonsParams,
  viewProductPageSfParams,
} from '@wix/bi-logger-ec-sf/v2/types';
import {updateWixCounters} from '../services/countersApi';
import {
  ProductPageItemData,
  SeoProductBuilder,
} from '@wix/wixstores-client-core/dist/es/src/builders/SeoItemData.builder';
import {SPECS} from '../specs';
import {WishlistActions} from '@wix/wixstores-client-storefront-sdk/dist/es/src/actions/WishlistActions/WishlistActions';
import {DirectPurchaseService} from '../services/DirectPurchaseService';
import {TrackEventName} from '@wix/wixstores-client-core/dist/es/src/types/track-event';
import {ResultProp, withChangeListener} from '../providers/withChangeListener';
import {
  GetFirstProductQuery,
  GetProductBySlugLargeQuery,
  GetProductBySlugQuery,
  GetStoreMetaDataQuery,
} from '../../graphql/queries-schema';
import {ShippingContactRestricted} from '@wix/cashier-express-checkout-widget/dist/src/types/Shipping';
import {PaymentAuthorizedArgs} from '@wix/cashier-express-checkout-widget/dist/src/types/ExternalContract';
import {AddToCartService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/AddToCartService';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {IFedOpsLogger} from '@wix/native-components-infra/dist/es/src/types/types';
import {ProductPriceService} from '../services/ProductPriceService';
import {DynamicPaymentMethodsTheme} from '@wix/wixstores-client-storefront-sdk/dist/es/src/enums/productPageSettings.enums';
import {Theme} from '@wix/cashier-express-checkout-widget/dist/src/types/Styles';
import {NavigationService} from '../services/NavigationService';
import {CustomUrlApi} from '@wix/wixstores-client-storefront-sdk/dist/es/src/utils/CustomUrl/CustomUrlApi';
import {
  IOptionSelectionVariant,
  IProductOptionSelectionItem,
} from '@wix/wixstores-client-core/dist/es/src/types/product';
import {
  BI_PRODUCT_OPTION_ACTION,
  BI_PRODUCT_OPTION_TYPE,
} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';
import {calcSelectionsAvailability} from '@wix/wixstores-client-core/dist/es/src/productVariantCalculator/ProductVariantCalculator';
import {
  ShippingContactSelectedUpdate,
  ShippingMethod,
  ShippingMethodSelectedUpdate,
} from '@wix/cashier-express-checkout-widget/src/types/Shipping';
import {ISentryErrorBoundaryPropsInjectedByViewerScript} from '@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import {getReleaseFromBaseUrl} from '@wix/native-components-infra/dist/es/src/sentryUtils/getReleaseFromBaseUrl';
import {HeadingTags} from '@wix/wixstores-client-core/dist/es/src/types/heading-tags';
import {CashierExpressService} from '../services/CashierExpressService';
import {ProductPriceBreakdown} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductPriceBreakdown/ProductPriceBreakdown';
import {ProductPriceRange} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductPriceRange/ProductPriceRange';
import {BackInStockStore} from './stores/BackInStockStore';
import {IProduct} from '@wix/wixstores-graphql-schema';
import {VolatileCartService} from '../services/VolatileCartService';
import {CheckoutApi} from '@wix/wixstores-client-storefront-sdk/dist/es/src/apis/CheckoutApi/CheckoutApi';
import {StoreMetaDataService} from '../services/StoreMetaDataService';
import {SubscriptionService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductSubscriptionService/SubscriptionService';
import {
  clickAddToWishlistSf,
  clickOnAddToCartSf,
  clickOnProductBoxSf,
  clickOnProductDetailsSf,
  clickOnProductOptionSf,
  clickRemoveFromWishlistSf,
  productAddedToWishlistSf,
  productRemovedFromWishlistSf,
  socialButtons,
  viewProductPageSf,
  viewQuickViewSf,
} from '@wix/bi-logger-ec-sf/v2';
import {ReportProps} from '@wix/web-bi-logger/dist/src/types';
import {BreadcrumbsService} from '../services/BreadcrumbsService';
import {NavigationService as NavigationContextService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductNavigation/NavigationService';
import {ITrackEventName, ITrackEventParams} from '@wix/native-components-infra';
import {createSlotVeloAPIFactory} from '@wix/widget-plugins-ooi/velo';
import {delay} from '../../commons/utils';
import {getStylesValues} from '@wix/tpa-settings';
import stylesParams, {IStylesParamsValues} from '../../components/ProductPage/stylesParams';

const MY_ACCOUNT_APP_DEF_ID = '14cffd81-5215-0a7f-22f8-074b0e2401fb';
const MEMBERS_INFO_SECTION_ID = 'member_info';

export class ProductPageStore {
  private readonly cashierExpressWidgetOnShippingMethodSelectedResult: ResultProp<ShippingMethodSelectedUpdate>;
  private directPurchaseService: DirectPurchaseService;
  private membersInstalled: boolean;
  private isStartReported: boolean = false;
  private media: IMediaItem[] = [];
  private readonly mergedPublicData: {[p: string]: any};
  private multilingualService: MultilingualService;
  private pagePath;
  private product: IProductDTO;
  private productAddedToWishlist: boolean;
  private readonly addToCartService: AddToCartService;
  private readonly customUrlApi: CustomUrlApi;
  private isUrlWithOverrides: boolean = false;
  private urlOverrideSegments?: {key: string; segments: {[key: string]: string}};
  private currentPath: string[];
  private readonly fedopsLogger: IFedOpsLogger;
  private readonly handleCashierOnClickResult: ResultProp<boolean>;
  private handleCashierPaymentSubmitResult: HandleCashierPaymentSubmitResult;
  private readonly navigationContext: IStoreFrontNavigationContext;
  private readonly productService: ProductService;
  private sectionUrl: string;
  private subscriptionService: SubscriptionService;
  private translations: TranslationDictionary;
  private translationsPromise: Promise<any>;
  public userInputs = userInputsFactory() as UserInput;
  private cashierExpressService: CashierExpressService;
  private productPriceBreakdown: ProductPriceBreakdown;
  private dynamicPaymentsMethodsAmount: number;
  private fetchPaymentBreakdownForCashierAddressResult: ResultProp<ShippingContactSelectedUpdate>;
  private readonly backInStockStore: BackInStockStore;
  private readonly volatileCartService: VolatileCartService;
  private readonly checkoutApi: CheckoutApi;
  private readonly storeMetaDataService: StoreMetaDataService;
  private siteSettingsCurrencies: ISiteSettingsCurrencies;
  private styles: IStylesParamsValues;

  constructor(
    private config: IProductPageControllerConfig,
    public origPublicData: IProductPageControllerConfig['publicData'],
    private readonly setProps: Function,
    private readonly siteStore: SiteStore,
    private readonly externalId: string,
    private readonly reportError: (e) => any,
    compId: string,
    private readonly slotAPIFactory: ReturnType<typeof createSlotVeloAPIFactory>,
    private readonly controllerConfig: IControllerFactoryConfig['controllerConfig']
  ) {
    this.updateStyles();
    const fedopsLoggerFactory = this.siteStore.platformServices.fedOpsLoggerFactory;
    this.fedopsLogger = fedopsLoggerFactory.getLoggerForWidget({
      appId: APP_DEFINITION_ID,
      widgetId: StoresWidgetID.PRODUCT_PAGE,
      fedopsAppName: this.isQuickView ? QUICK_VIEW_APP_NAME : PRODUCT_PAGE_APP_NAME,
    });
    /* istanbul ignore next: todo: test */
    if (isWorker()) {
      this.fedopsLogger.appLoadStarted();
      this.isStartReported = true;
    }
    this.productService = new ProductService({
      siteStore,
      withPriceRange: this.shouldRenderPriceRange,
      origin: this.biOrigin,
    });
    this.navigationContext = this.getNavigationContext();
    const publicData = _.cloneDeep(this.origPublicData);
    this.currentPath = this.siteStore.location.path;

    this.customUrlApi = new CustomUrlApi(this.siteStore.location.buildCustomizedUrl);

    /* istanbul ignore next: quick hack for bsi */
    if (this.isQuickView) {
      try {
        const commonConfig = this.getQueryParam('commonConfig');
        const bsi = JSON.parse(commonConfig).bsi;
        (this.siteStore.webBiLogger.report as any).updateDefaults({_bsi: bsi});
      } catch (_e) {
        //
      }
    }

    this.addToCartService = new AddToCartService(siteStore, publicData);
    this.storeMetaDataService = new StoreMetaDataService(this.siteStore);
    this.volatileCartService = new VolatileCartService(this.siteStore, this.storeMetaDataService, this.reportError);
    this.checkoutApi = new CheckoutApi({siteStore: this.siteStore, origin: Origin.PRODUCT_PAGE});

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    this.siteStore.location.onChange((data) => {
      if (this.siteStore.experiments.enabled(SPECS.LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE)) {
        this.currentPath = this.siteStore.location.path;
      }

      const isNavigatedToProductPage =
        this.siteStore.experiments.enabled(SPECS.LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE) &&
        this.siteStore.isEditorMode() &&
        data.path[data.path.length - 2] === this.currentPath[this.currentPath.length - 2];

      /* istanbul ignore next: todo: test */
      const previewModePPLocationChanged =
        this.siteStore.isPreviewMode() &&
        data.path[data.path.length - 1] === this.currentPath[this.currentPath.length - 1];

      /* istanbul ignore else: todo: test */
      if (previewModePPLocationChanged || isNavigatedToProductPage || data.path[0] === this.currentPath[0]) {
        return this.setInitialState()
          .then(() => this.reportBIOnAppLoaded())
          .catch(this.reportError);
      }
    });

    this.mergedPublicData = this.getMergedPublicData(publicData);
    this.backInStockStore = new BackInStockStore({
      siteStore: this.siteStore,
      setProps: (props) => this.setProps(props),
      resolveProductId: /* istanbul ignore next todo(titk@wix.com): remove when modal is implemented */ () =>
        this.product.id,
      resolveVariantId: /* istanbul ignore next todo(titk@wix.com): remove when modal is implemented */ () =>
        this.product.isManageProductItems ? this.selectedVariant.id : this.product.productItems[0].id,
      compId,
      canCreateBackInStockRequest: /* istanbul ignore next todo(tymofiih@wix.com): enzyme rendering issue` */ () =>
        this.validateProductSubmission(),
      biLogger: this.siteStore.webBiLogger,
    });
  }

  protected updateStyles() {
    const {
      style: {styleParams},
    } = this.config;
    this.styles = getStylesValues(styleParams, stylesParams, {isMobile: this.siteStore.isMobile()}) as any;
  }

  private get sentryErrorBoundaryProps(): ISentryErrorBoundaryPropsInjectedByViewerScript {
    return {
      ravenUserContextOverrides: {id: this.siteStore.storeId, uuid: this.siteStore.uuid as string},
      sentryRelease: getReleaseFromBaseUrl(this.siteStore.baseUrls.productPageBaseUrl, {
        artifactName: true,
      }),
    };
  }

  private isMembersInstalled(): Promise<boolean> {
    const isLegacyMembersInstalledPromise = this.siteStore.siteApis.isAppSectionInstalled({
      appDefinitionId: '14cffd81-5215-0a7f-22f8-074b0e2401fb',
      sectionId: 'member_info',
    });

    const isMembersInstalledPromise = this.siteStore.siteApis.isAppSectionInstalled({
      appDefinitionId: 'b976560c-3122-4351-878f-453f337b7245',
      sectionId: 'member_page',
    });

    return Promise.allSettled([isLegacyMembersInstalledPromise, isMembersInstalledPromise]).then((results) => {
      const fulfilledResults = results.filter((result) => result.status === 'fulfilled');
      return fulfilledResults.some((result) => (result as PromiseFulfilledResult<boolean>).value === true);
    });
  }

  public async setInitialState(): Promise<void> {
    this.sectionUrl = (await this.siteStore.getSectionUrl(PageMap.PRODUCT)).url;

    const productPageWishlistWithNewMembersArea = this.siteStore.experiments.enabled(
      SPECS.ProductPageWishlistWithNewMembersArea
    );

    const isMembersInstalledPromise = productPageWishlistWithNewMembersArea
      ? this.isMembersInstalled()
      : this.siteStore.siteApis.isAppSectionInstalled({
          appDefinitionId: MY_ACCOUNT_APP_DEF_ID,
          sectionId: MEMBERS_INFO_SECTION_ID,
        });

    this.isUrlWithOverrides = await this.customUrlApi.init();
    if (this.isUrlWithOverrides) {
      this.urlOverrideSegments = await this.getCustomizedUrlSegments();
    }

    const initialDataPromises: Promise<
      | TranslationDictionary
      | {
          product: IProductDTO;
          appSettings: IAppSettings;
          siteSettingsCurrencies: ISiteSettingsCurrencies;
        }
      | boolean
      | void
      | GetStoreMetaDataQuery
    >[] = [
      this.getProductPageTranslations(),
      this.getInitialData(),
      isMembersInstalledPromise,
      this.backInStockStore.initialize(),
    ];

    if (this.siteStore.experiments.enabled(SPECS.UseNewExpressCheckoutButtonsInProductPage)) {
      initialDataPromises.push(
        // StoreMetaData need for isAllowedToCheckout flag. In case of error - proceed render because we will try to re-fetch it on onClick.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.storeMetaDataService.fetchStoreInfo().catch(/* istanbul ignore next nothing to test) */ () => {})
      );

      /* istanbul ignore next */
      if (!this.directPurchaseService) {
        this.createDirectPurchaseService();
      }
    }

    const [translations, {product, appSettings, siteSettingsCurrencies}, membersInstalled] = await Promise.all(
      initialDataPromises
    ).catch(this.reportError);

    this.product = product;
    this.initSlots();
    this.siteSettingsCurrencies = siteSettingsCurrencies;
    this.translations = translations;
    this.productPriceBreakdown = new ProductPriceBreakdown(this.siteStore, this.translations, {
      excludedPattern: 'productPage.price.tax.excludedParam.label',
      includedKey: 'productPage.price.tax.included.label',
      includedPattern: 'productPage.price.tax.includedParam.label',
      excludedKey: 'productPage.price.tax.excluded.label',
    });

    this.multilingualService = new MultilingualService(
      this.siteStore,
      this.mergedPublicData,
      appSettings.widgetSettings
    );
    this.pagePath = await new BreadcrumbsService(
      this.siteStore,
      this.navigationContext,
      this.product,
      this.translations
    ).getPagePath();

    if (!this.product) {
      return this.handleEmptyState();
    }

    this.productAddedToWishlist = false;
    this.membersInstalled = membersInstalled;
    this.media = product.media;
    this.productService.updateOptions(this.product);
    this.setInitialUserInputs();
    if (!this.isQuickView) {
      this.siteStore.pubSub.publish(PubSubEvents.RELATED_PRODUCTS, [this.product.id], true);
    }

    /* istanbul ignore next: todo: test */
    this.subscriptionService = new SubscriptionService(this.product.subscriptionPlans, {
      label: this.translations.PRODUCT_PAGE_ONE_TIME_PURCHASE_LABEL,
      place: this.styles.productPage_subscriptionPlansOneTimePurchase,
      price: this.product.formattedComparePrice || this.product.formattedPrice,
    });

    this.cashierExpressService = new CashierExpressService(this.siteStore, this.checkoutApi, this.volatileCartService);
    const initialProps = this.initialProps;

    /* istanbul ignore next: todo: test */
    if (this.siteStore.experiments.enabled(SPECS.UseNewExpressCheckoutButtonsInProductPage)) {
      const expressCheckoutButtonsController = createExpressCheckoutButtonsController({
        getCheckoutId: async () => {
          const checkoutId = await this.cashierExpressService.createCheckout(
            this.product,
            this.userInputs,
            this.isPreOrderState()
          );
          this.cashierExpressService.logBiClickOnCheckoutWithEWallet(this.product);
          return checkoutId;
        },
        onClick: () => this.handleExpressCashierOnClick(),
        onPaymentMethodsInit: /* istanbul ignore next */ ({numberOfButtons}) =>
          this.setDynamicPaymentsMethodsAmount(numberOfButtons),
        getCurrency: () => initialProps.cashierExpressCheckoutWidgetProps.currency,
        controllerConfig: this.controllerConfig,
        httpClient: this.controllerConfig.essentials.httpClient,
        demoMode: this.siteStore.isEditorMode(),
        widgetId: StoresWidgetID.PRODUCT_PAGE,
        locale: this.siteStore.locale,
      });

      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      expressCheckoutButtonsController.init();
    }

    this.setProps(initialProps);
    this.trackViewContent();
    this.setPageMetaData();
    if (this.siteStore.isSSR()) {
      this.fedopsLogger.appLoaded();
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  private initSlots() {
    const reviewsSlotIds = Object.values(ReviewsSlotIds);
    for (const slotId of reviewsSlotIds) {
      try {
        const slot = this.slotAPIFactory.getSlotAPI(slotId);
        slot.namespace = STORES_NAMESPACE;
        slot.resourceId = this.product?.id;
      } catch (e) {
        /* istanbul ignore next: nothing to test  */
        this.reportError(e);
      }
    }

    if (this.siteStore.experiments.enabled(SPECS.PRODUCT_PAGE_SLOTS)) {
      const productPageSlotIds = Object.values(ProductPageSlotIds);
      for (const slotId of productPageSlotIds) {
        try {
          const slot = this.slotAPIFactory.getSlotAPI(slotId);
          slot.productId = this.product?.id;
        } catch (e) {
          /* istanbul ignore next: nothing to test  */
          this.reportError(e);
        }
      }
    }
  }

  private getMergedPublicData(publicData: IProductPageControllerConfig['publicData']) {
    if (this.isQuickView) {
      return {...publicData.APP, ...publicData.COMPONENT};
    }

    const componentKeys = ['productPage_infoSectionTitleHtmlTag'];
    const componentPublicData = _.pick(publicData.COMPONENT, componentKeys);
    return {...publicData.APP, ...componentPublicData};
  }

  private reportBIOnAppLoaded() {
    const params: viewProductPageSfParams = this.product
      ? {
          isMobileFriendly: this.siteStore.isMobileFriendly,
          addToCart: this.styles.productPage_buyNowButtonEnabled,
          buyNow: this.styles.productPage_buyNowButtonEnabled,
          hasDynamicPaymentMethods: this.styles.productPage_dynamicPaymentMethodsEnabled,
          hasPlans: hasSubscriptionPlans(this.product),
          hasWishlist: this.styles.productPage_wishlistEnabled,
          inventoryStatus: this.biProductInventoryStatus,
          navigationClick: this.getAddToCartActionText(),
          oneTimePurchase: hasSubscriptionPlans(this.product) && this.subscriptionService.hasOneTimePurchase(),
          options: JSON.stringify(
            this.product.options.map((o) => ({
              type: o.optionType,
              size: o.selections.length,
            }))
          ),
          priceBreakdown: this.productPriceBreakdown.priceBreakdownBIParam,
          productId: this.product.id,
          productType: this.product.productType,
          showUnitPrice: !!this.product.pricePerUnit,
          hasNotifyMe: this.backInStockStore.isBackInStockEnabled,
          preOrderNow:
            this.isPreOrderState() &&
            this.styles.productPage_buyNowButtonEnabled &&
            !this.styles.productPage_productAction,
          preOrder: this.isPreOrderState() && this.styles.productPage_productAction,
          socialButton: [SocialVendor.Facebook, SocialVendor.Pinterest, SocialVendor.Twitter, SocialVendor.WhatsApp]
            .filter((v) => this.styles[`productPage_socialNetwork${v}`])
            .join(', '),
          hasStockIndicator: this.styles.productPage_stockIndicator,
          remainingItemCount: this.remainingItemCount > 0 ? this.remainingItemCount : undefined,
        }
      : {productId: ''};
    if (this.isQuickView) {
      /* istanbul ignore next: can't test implicit field */
      (params as any)._viewMode = this.siteStore.isPreviewMode() ? 'preview' : 'site';
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.siteStore.webBiLogger.report(viewQuickViewSf(params));
    } else {
      params.type = LayoutNames[this.layoutId] as Layout;
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.siteStore.webBiLogger.report(viewProductPageSf(params));
    }
  }

  private reportToWiXCounters() {
    return updateWixCounters(this.siteStore, this.product.id, this.siteStore.uuid);
  }

  public onAppLoaded = () => {
    /* istanbul ignore else: todo: test */
    if (!isWorker() || /* istanbul ignore next */ (this.siteStore.isInteractive() && this.isStartReported)) {
      if (this.siteStore.isSiteMode()) {
        this.product && this.reportToWiXCounters();
      }
      this.reportBIOnAppLoaded();
      this.fedopsLogger.appLoaded();
      this.isStartReported = false;
    }
  };

  private getAddToCartActionText() {
    // eslint-disable-next-line no-nested-ternary
    return this.getAddToCartAction() === AddToCartActionOption.MINI_CART
      ? 'mini-cart'
      : this.getAddToCartAction() === AddToCartActionOption.CART
      ? 'cart'
      : 'none';
  }

  public updateState(
    config: IProductPageControllerConfig,
    newPublicData: IProductPageControllerConfig['publicData'] & {appSettings?: any}
  ): void {
    _.merge(this.mergedPublicData, this.getMergedPublicData(newPublicData));
    this.config = config;
    this.updateStyles();

    // In EditorOOI mode in TB appSettings are not passed
    if (newPublicData.appSettings) {
      this.multilingualService.setWidgetSettings(newPublicData.appSettings);
    }
    this.setProps({
      ...this.getChangeableSettingsProps(),
    });
  }

  /* istanbul ignore next: todo test */
  public updateAppSettings(appSettings?: any) {
    this.multilingualService.setWidgetSettings(appSettings);
    this.setProps({
      ...this.getChangeableSettingsProps(),
    });
  }

  private getTexts() {
    const componentAddToCartTextKey = Object.keys(this.multilingualService.getAll() || {}).find((key) =>
      COMPONENTS_ADD_TO_CART_TEXT_KEYS.includes(key)
    );

    if (componentAddToCartTextKey) {
      MULTILINGUAL_TO_TRANSLATIONS_MAP.ADD_TO_CART_BUTTON = componentAddToCartTextKey;
    }

    const componentOutOfStockTextKey = Object.keys(this.multilingualService.getAll() || {}).find((key) =>
      COMPONENTS_OUT_OF_STOCK_TEXT_KEYS.includes(key)
    );

    if (componentOutOfStockTextKey) {
      MULTILINGUAL_TO_TRANSLATIONS_MAP.PRODUCT_OUT_OF_STOCK_BUTTON = componentOutOfStockTextKey;
    }

    /* istanbul ignore next */
    const componentBackInStockTextKey = Object.keys(this.multilingualService.getAll() || {}).find((key) =>
      COMPONENTS_BACK_IN_STOCK_TEXT_KEYS.includes(key)
    );

    /* istanbul ignore next */
    const componentPreOrderTextKey = Object.keys(this.multilingualService.getAll() || {}).find((key) =>
      COMPONENTS_PRE_ORDER_TEXT_KEYS.includes(key)
    );

    /* istanbul ignore next */
    const componentPreOrderBuyNowTextKey = Object.keys(this.multilingualService.getAll() || {}).find((key) =>
      COMPONENTS_PRE_ORDER_BUY_NOW_TEXT_KEYS.includes(key)
    );

    if (componentBackInStockTextKey) {
      MULTILINGUAL_TO_TRANSLATIONS_MAP['productPage.backInStock.notifyWhenAvailable.button'] =
        componentBackInStockTextKey;
    }

    if (componentPreOrderTextKey) {
      MULTILINGUAL_TO_TRANSLATIONS_MAP['productPage.preOrder.button'] = componentPreOrderTextKey;
    }

    if (componentPreOrderBuyNowTextKey) {
      MULTILINGUAL_TO_TRANSLATIONS_MAP['productPage.preOrderNow.button'] = componentPreOrderBuyNowTextKey;
    }

    return Object.keys(MULTILINGUAL_TO_TRANSLATIONS_MAP).reduce(
      (acc, translationKey) => {
        const multiligualKey = MULTILINGUAL_TO_TRANSLATIONS_MAP[translationKey];
        const override = this.multilingualService.get(multiligualKey);
        if (override) {
          acc[translationKey] = override;
        }
        return acc;
      },
      {...this.translations}
    );
  }

  private getChangeableSettingsProps(): Partial<IPropsInjectedByViewerScript> {
    this.subscriptionService.setOneTimePurchasePlace(this.styles.productPage_subscriptionPlansOneTimePurchase);

    return {
      layoutId: this.layoutId,
      shouldShowAddToCartButton: this.styles.productPage_productAction,
      shouldShowBuyNowButton: this.styles.productPage_buyNowButtonEnabled,
      shouldShowProductPaymentBreakdown: this.shouldShowProductPaymentBreakdown,
      priceBreakdown: {
        shouldRenderTaxDisclaimer: this.productPriceBreakdown.shouldShowTaxDisclaimer,
        taxDisclaimer: this.productPriceBreakdown.taxDisclaimer,
        shippingDisclaimer: this.productPriceBreakdown.shippingDisclaimer,
      },
      shouldShowDiscountName: this.shouldShowDiscountName,
      shouldShowWishlistButton: this.styles.productPage_wishlistEnabled && this.membersInstalled,
      dynamicPaymentMethodsTheme: this.getDynamicPaymentMethodsTheme(),
      dynamicPaymentMethodsEnabled: this.styles.productPage_dynamicPaymentMethodsEnabled,
      subscriptionPlans: this.subscriptionService.getSubscriptionPlans(),
      breakdownParams: this.breakdownParams,
      htmlTags: this.getHtmlTags(),
      texts: this.getTexts(),
      withModalGallery: this.withModalGallery,
    };
  }

  private get shouldRenderPriceRange(): boolean {
    return new ProductPriceRange(this.siteStore).shouldShowPriceRange();
  }

  private readonly shouldShowSubscribeButton = (): boolean => {
    return this.subscriptionService.shouldShowSubscribeButton(this.userInputs);
  };

  private getDynamicPaymentMethodsTheme(): Theme | undefined {
    /* istanbul ignore next: todo: test */
    if (this.styles.productPage_dynamicPaymentMethodsButtonTheme === DynamicPaymentMethodsTheme.light) {
      return 'light';
    } else if (this.styles.productPage_dynamicPaymentMethodsButtonTheme === DynamicPaymentMethodsTheme.dark) {
      return 'dark';
    }
  }

  /* istanbul ignore next: todo: test */
  private readonly setDynamicPaymentsMethodsAmount = (amount: number) => {
    this.dynamicPaymentsMethodsAmount = amount;
    this.nextProps();
  };

  private get initialProps(): Partial<IPropsInjectedByViewerScript> {
    return {
      ...this.defaultProps,
      ...this.getChangeableSettingsProps(),
      ...this.sentryErrorBoundaryProps,
      addedToCartStatus: AddToCartActionStatus.IDLE,
      addToCartState: this.addToCartState,
      reportBI: this.reportBI,
      cashierExpressCheckoutWidgetProps: this.cashierExpressService.getInitialProps(
        this.product,
        this.styles.productPage_dynamicPaymentMethodsButtonShape,
        this.siteSettingsCurrencies?.checkoutCurrencies
      ),
      cashierExpressWidgetOnShippingMethodSelected: this.cashierExpressWidgetOnShippingMethodSelected,
      cashierExpressWidgetOnShippingMethodSelectedResult: this.cashierExpressWidgetOnShippingMethodSelectedResult,
      cashierExpressPaymentBreakdown: this.getCashierExpressPaymentBreakdown(),
      cashierExpressEstimatedTotal: this.getCashierExpressEstimatedTotal(),
      closeWixModal: this.closeWixModal.bind(this),
      currentPrice: this.currentPrice,
      dynamicPaymentsMethodsAmount: undefined,
      fitToContentHeight: true, // thunderbolt prop that sets height: auto on the widget instead of fixed height https://wix.slack.com/archives/C011YKHSSB1/p1648551046454209
      isPreOrderState: this.isPreOrderState(),
      errorPlacement:
        this.siteStore.isMobile() || this.isQuickView ? ErrorTooltipPlacement.Bottom : ErrorTooltipPlacement.Left,
      errors: {},
      fetchPaymentBreakdownForCashierAddress: this.fetchPaymentBreakdownForCashierAddress,
      handleAddToCart: this.handleAddToCart,
      handleBuyNow: this.handleBuyNow,
      ...this.backInStockStore.props,
      handleCashierOnClick: this.handleCashierOnClick,
      handleCashierOnClickResult: this.handleCashierOnClickResult,
      handleCashierPaymentSubmit: this.handleCashierPaymentSubmit,
      handleCashierPaymentSubmitResult: this.handleCashierPaymentSubmitResult,
      handleOpenModal: this.siteStore.windowApis.openModal.bind(this.siteStore.windowApis),
      handleSubscribe: this.handleSubscribe,
      handleUserInput: this.handleUserInput,
      handleWishlistButtonClick: this.handleWishlistButtonClick,
      hasMultipleMedia: this.product.media.length > 1,
      hideNavigationUrls: !this.siteStore.isSiteMode(),
      infoSection: this.infoSection,
      isDesktop: this.siteStore.isDesktop(),
      isEditorMode: this.siteStore.isEditorMode(),
      isEditorX: this.isEditorX,
      isMobile: this.siteStore.isMobile(),
      isAllowedToCheckout: this.isAllowedToCheckout,
      isProductSubmitted: false,
      isQuickView: this.isQuickView,
      isRTL: this.siteStore.isRTL(),
      isResponsive: this.layoutId === LayoutId.Responsive,
      isSEO: this.siteStore.seo.isInSEO(),
      isSSR: this.siteStore.isSSR(),
      modalState: ModalState.CLOSE,
      navigate: this.navigate.bind(this),
      navigateToLink: /* istanbul ignore next */ (link) => {
        if (link.relativeUrl) {
          this.siteStore.location.to(link.relativeUrl);
        } else {
          this.siteStore.location.navigateTo(link.sdkLink);
        }
      },
      notifyProduct: this.notifyProductLoaded,
      pagination: this.getPrevNextProducts(),
      product: this.product,
      productUrl: this.productUrl,
      productWasAddedToWishlist: this.productAddedToWishlist,
      quantityRange: this.quantityRange,
      remainingItemCount: this.remainingItemCount,
      resetAddedToCartStatus: this.resetAddedToCartStatus,
      resetWishlistStatus: this.resetWishlistStatus,
      selectedVariant: this.selectedVariant,
      setDynamicPaymentsMethodsAmount: this.setDynamicPaymentsMethodsAmount,
      shouldFocusAddToCartButton: false,
      shouldShowAddToCartSuccessAnimation: this.getAddToCartAction() === AddToCartActionOption.NONE,
      shouldShowSubscribeButton: this.shouldShowSubscribeButton(),
      shouldShowSubscriptionPlans: this.subscriptionService.shouldShowSubscriptionPlans,
      shouldShorUserInputs: this.shouldShowUserInputs,
      siteUrl: this.siteStore.location.baseUrl,
      socialSharing: this.socialSharing,
      subscriptionPlans: this.subscriptionService.getSubscriptionPlans(),
      userInputErrors: userInputsFactory() as UserInputErrors,
      userInputs: this.userInputs,
      validate: this.validate,
      variantInfo: this.variantInfo,
      wishlistActionStatus: ActionStatus.IDLE,
    };
  }

  private get defaultProps() {
    return {
      onAppLoaded: this.onAppLoaded,
      experiments: {
        jpgExperiment: this.siteStore.experiments.enabled('specs.stores.SSRJpgImageForPng'),
        useDropdownTpaLabel: this.siteStore.experiments.enabled(SPECS.USE_DROPDOWN_TPA_LABEL),
        disableMobileNativeDropdown: this.siteStore.experiments.enabled(SPECS.DISABLE_MOBILE_NATIVE_DROPDOWN),
        isSubscriptionPlanTpaRadioButton: this.siteStore.experiments.enabled(
          SPECS.SUBSCRIPTION_PLAN_USE_TPA_RADIO_BUTTON
        ),
        CartTooltipWithoutNumber: this.siteStore.experiments.enabled(SPECS.CART_TOOLTIP_WITHOUT_NUMBER),
        activeDisabledVariants: this.siteStore.experiments.enabled(SPECS.ACTIVE_DISABLED_VARIANTS),
        UseNewExpressCheckoutButtonsInProductPage: this.siteStore.experiments.enabled(
          SPECS.UseNewExpressCheckoutButtonsInProductPage
        ),
        renderProductPageSlots: this.siteStore.experiments.enabled(SPECS.PRODUCT_PAGE_SLOTS),
        shouldUseCommonDiscountPricingMethods: this.shouldUseCommonDiscountPricingMethods,
        dropdownLabelFor: this.siteStore.experiments.enabled(SPECS.DROPDOWN_LABEL_FOR),
        productPageRicoDescription: this.siteStore.experiments.enabled(SPECS.PRODUCT_PAGE_RICO_DESCRIPTION),
        productPageWithoutGlobalCss: this.siteStore.experiments.enabled(SPECS.PRODUCT_PAGE_WITHOUT_GLOBAL_CSS),
        breadcrumbsAfterHydration: this.siteStore.experiments.enabled(SPECS.BREADCRUMBS_AFTER_HYDRATION),
        EnableDynamicSizeDefaultImage: this.siteStore.experiments.enabled(SPECS.EnableDynamicSizeDefaultImage),
      },
      isInteractive: this.siteStore.isInteractive(),
      cssBaseUrl: this.siteStore.baseUrls.productPageBaseUrl,
      pagePath: this.pagePath,
      htmlTags: this.getHtmlTags(),
      texts: this.getTexts(),
      instanceId: this.siteStore.instanceManager.getInstance(),
    } as Partial<IPropsInjectedByViewerScript>;
  }

  private get isAllowedToCheckout(): boolean {
    if (!this.siteStore.experiments.enabled(SPECS.UseNewExpressCheckoutButtonsInProductPage)) {
      return false;
    }

    /* istanbul ignore next */
    if (!this.directPurchaseService) {
      this.createDirectPurchaseService();
    }

    const {isInvalid} = this.isInvalid(this.userInputs);

    if (isInvalid) {
      return false;
    }

    return this.directPurchaseService.checkIsAllowedToCheckoutSync(this.product).canCheckout;
  }

  private get isEditorX(): boolean {
    return this.styles?.responsive === true;
  }

  private isPreOrderState() {
    const isProductExists = !!this.product;
    return isProductExists && isPreOrder(this.product, this.selectedVariant);
  }

  private get withModalGallery() {
    const hasMedia = this.product.media.length > 0;
    const isViewer = !this.siteStore.isPreviewMode() && !this.siteStore.isEditorMode();
    const applicable = this.styles.productPage_galleryZoom === true || this.siteStore.isMobile();
    const allowedInLayout = [LayoutId.Responsive, LayoutId.Classic].includes(this.layoutId);
    return applicable && hasMedia && isViewer && allowedInLayout;
  }

  private setInitialUserInputs() {
    const textFieldsLength = this.product.customTextFields ? this.product.customTextFields.length : 0;
    const quantity = this.passedQuantity;
    const selection = this.product.options.reduce((acc, option, i) => {
      if (this.passedSelections.length) {
        acc[i] = this.passedSelections.find(({id: selectionId}) => {
          return option.selections.find((item) => item.id === selectionId);
        });
      }

      if (!acc[i]) {
        const shouldPreselect = option.selections.length > 1;
        acc[i] = shouldPreselect ? null : option.selections[0];
      }

      return acc;
    }, []);

    this.userInputs = {
      selection,
      quantity: [quantity],
      text: Array(textFieldsLength).fill(null),
      subscriptionPlan: [],
    };

    this.updateSelections();
  }

  private readonly socialSharing = {
    onClick: (data: SocialSharingEvent) => {
      const socialSharingEventWithProduct: socialButtonsParams = {...data, productId: this.product.id};
      return this.siteStore.webBiLogger.report(socialButtons(socialSharingEventWithProduct));
    },
  };

  private readonly infoSection = {
    onActive: (BIEvent: InfoSectionEvent) => {
      const infoSectionEventWithProduct: clickOnProductDetailsSfParams = {...BIEvent, productId: this.product.id};
      return this.siteStore.webBiLogger.report(clickOnProductDetailsSf(infoSectionEventWithProduct));
    },
  };

  private getProductPageTranslations(): Promise<TranslationDictionary> {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (this.translationsPromise) {
      return this.translationsPromise;
    }
    this.translationsPromise = getTranslations(
      translationPath(this.siteStore.baseUrls.productPageBaseUrl, this.siteStore.locale)
    );
    return this.translationsPromise;
  }

  private readonly navigate = (productUrlPart: string, closeWixModal: boolean = false): void => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.siteStore.navigate({
      sectionId: PageMap.PRODUCT,
      queryParams: undefined,
      state: productUrlPart,
    });

    if (closeWixModal) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.siteStore.webBiLogger.report(
        clickOnProductBoxSf({
          productId: this.product.id,
          hasRibbon: !!this.product.ribbon,
          hasOptions: !!this.product.options.length,
          index: 0,
          productType: this.product.productType,
          origin: 'quick-view',
        })
      );
      this.closeWixModal();
    }
  };

  private closeWixModal() {
    this.siteStore.windowApis.closeWindow();
  }

  private readonly handleUserInput = (inputType: UserInputType, data: UserInputData = null, index: number) => {
    const prevData = this.userInputs[inputType][index];

    this.userInputs[inputType][index] = data;
    if (this.siteStore.experiments.enabled(SPECS.ACTIVE_DISABLED_VARIANTS)) {
      const selectionAvailability = this.getVariantAvailabilityById((data as IProductOptionSelection).id);
      if (!selectionAvailability) {
        this.resetProductOptionsExceptSelectionInIndex(index);
      }
    }

    /* istanbul ignore else: todo: test */
    if (this.siteStore.experiments.enabled(SPECS.FIX_CASHIER_PROPS_PRICE_SHIFTING)) {
      this.volatileCartService.resetCart();
    }

    if (
      this.siteStore.experiments.enabled(SPECS.SHOULD_RESET_QUANTITY_UPON_SELECTION_CHANGE) &&
      inputType === UserInputType.Selection
    ) {
      this.resetQuantityUponSelectionChange();
    }

    this.updateSelections();
    this.nextProps();
    this.notifyUserInput();

    if (inputType === UserInputType.Selection) {
      this.sendClickOnProductOptionBiEvent(
        data as IProductOptionSelectionItem,
        prevData as IProductOptionSelectionItem
      );
    }
  };

  private notifyUserInput() {
    const isValid = !this.isInvalid(this.userInputs).isInvalid;
    if (isValid) {
      this.notifyCustomizeProduct();
    }
  }

  private resetProductOptionsExceptSelectionInIndex(index: number) {
    this.userInputs.selection.forEach((selection) => {
      const indexOfSelection = this.userInputs.selection.indexOf(selection);
      if (indexOfSelection !== index || this.userInputs.selection.length === 1) {
        this.userInputs.selection[indexOfSelection] = null;
      }
    });
  }

  private getVariantAvailabilityById(id): boolean {
    const variantsInfo = this.variantInfo.selectionsAvailability;
    for (const option in variantsInfo) {
      if (variantsInfo[option][id]) {
        return variantsInfo[option][id].isVisible;
      }
    }
  }

  private resetQuantityUponSelectionChange() {
    this.userInputs.quantity = [1];
  }

  private readonly updateSelections = () => {
    this.productService.options.updateSelections(this.product, this.userInputs.selection);
    this.filterMedia();
  };

  private readonly nextProps = (additionalProps = {} as Partial<IPropsInjectedByViewerScript>) => {
    const nextProps: Partial<IPropsInjectedByViewerScript> = {
      addToCartState: this.addToCartState,
      breakdownParams: this.breakdownParams,
      currentPrice: this.currentPrice,
      isPreOrderState: this.isPreOrderState(),
      cashierExpressPaymentBreakdown: this.getCashierExpressPaymentBreakdown(),
      cashierExpressEstimatedTotal: this.getCashierExpressEstimatedTotal(),
      dynamicPaymentsMethodsAmount: this.dynamicPaymentsMethodsAmount,
      handleCashierPaymentSubmitResult: this.handleCashierPaymentSubmitResult,
      fetchPaymentBreakdownForCashierAddressResult: this.fetchPaymentBreakdownForCashierAddressResult,
      product: this.product,
      quantityRange: this.quantityRange,
      remainingItemCount: this.remainingItemCount,
      selectedVariant: this.selectedVariant,
      shouldShowSubscribeButton: this.shouldShowSubscribeButton(),
      subscriptionPlans: this.subscriptionService.getSubscriptionPlans(),
      shouldShowProductPaymentBreakdown: this.shouldShowProductPaymentBreakdown,
      shouldShowDiscountName: this.shouldShowDiscountName,
      userInputs: this.userInputs,
      variantInfo: this.variantInfo,
      isAllowedToCheckout: this.isAllowedToCheckout,
      ...additionalProps,
    };
    this.setProps(nextProps);
  };

  private readonly getCashierExpressPaymentBreakdown = () => {
    return this.cashierExpressService.getPaymentBreakdown(this.product, this.selectedVariant, this.userInputs);
  };

  private readonly getCashierExpressEstimatedTotal = () => {
    return this.cashierExpressService.getEstimatedPrice(this.product, this.selectedVariant, this.userInputs);
  };

  public readonly validate = (): void => {
    this.nextProps({
      userInputErrors: this.productService.validate(this.userInputs),
    });
  };

  private readonly createDirectPurchaseService = () => {
    this.directPurchaseService = new DirectPurchaseService(
      this.siteStore,
      this.reportError,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      (buttonType: BiButtonActionType) => this.reportButtonAction(buttonType),
      this.nextProps,
      this.fedopsLogger,
      this.trackDirectPurchase,
      () => this.isQuickView && this.closeWixWindow(),
      this.isEditorX,
      this.multilingualService,
      this.storeMetaDataService
    );
  };

  private readonly trackDirectPurchase = ({checkoutId}: {checkoutId: string}) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {appDefId, origin, sku, type, brand, ...contents} = this.trackParams;
    const eventParams = {
      ...this.trackParams,
      checkoutId,
    };

    this.siteStore.windowApis.trackEvent(TrackEventName.ADD_TO_CART, eventParams as ITrackEventParams);
    return this.siteStore.windowApis.trackEvent(TrackEventName.INITIATE_CHECKOUT, {
      ...eventParams,
      contents: [contents],
    } as ITrackEventParams);
  };

  private readonly validateProductSubmission = (): boolean => {
    const validationObject = this.isInvalid(this.userInputs);
    if (validationObject.isInvalid) {
      this.nextProps({
        isProductSubmitted: true,
        userInputErrors: validationObject.validations,
      });
      return false;
    } else {
      return true;
    }
  };

  private readonly closeWixWindow = () => {
    return delay(100).then(() => this.siteStore.windowApis.closeWindow());
  };

  private readonly handleExpressCashierOnClick = (): void => {
    const shouldProceed = this.validateProductSubmission();
    if (!shouldProceed) {
      return;
    }
    this.cashierExpressService.handleExpressCashierOnClick(this.product, this.directPurchaseService);
  };

  /* istanbul ignore next: todo: test */
  private readonly handleCashierOnClick = async () => {
    if (!this.directPurchaseService) {
      this.createDirectPurchaseService();
    }

    // eslint-disable-next-line @typescript-eslint/await-thenable
    const shouldProceed = await this.validateProductSubmission();
    /* istanbul ignore next: todo(eran): this await is an hack until I fix this: https://wix.slack.com/archives/C68TQQSNM/p1595256383021500*/
    if (!shouldProceed) {
      this.nextProps({handleCashierOnClickResult: withChangeListener(false)});
      return;
    }

    const canCheckout = await this.cashierExpressService.handleCashierOnClick(
      this.product,
      this.directPurchaseService,
      this.userInputs,
      this.isPreOrderState()
    );

    this.nextProps({handleCashierOnClickResult: withChangeListener(canCheckout)});
  };

  /* istanbul ignore next: todo: test */
  private readonly handleCashierPaymentSubmit = async (
    paymentInfo: PaymentAuthorizedArgs,
    accessibilityEnabled: boolean
  ) => {
    const result = await this.cashierExpressService.handleCashierPaymentSubmit(
      paymentInfo,
      accessibilityEnabled,
      this.product
    );
    if (result === 'shouldNavigateToCheckout') {
      const to: CheckoutStageWithCartParams = {
        accessibilityEnabled,
        cashierPaymentId: paymentInfo.detailsId,
      };

      if (this.volatileCartService.checkoutId) {
        to.checkoutId = this.volatileCartService.checkoutId;
      }

      await this.directPurchaseService.handleCheckoutStageWithExistingCart(to);
      this.handleCashierPaymentSubmitResult = withChangeListener({result: 'success'});
      this.nextProps();
    } else if (result === 'success') {
      this.handleCashierPaymentSubmitResult = withChangeListener({result: 'success'});
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.cashierExpressService.onCashierExpressPaymentSuccess();
      this.nextProps();
    } else {
      this.handleCashierPaymentSubmitResult = withChangeListener({result: 'error'});
      this.nextProps();
    }
  };

  /* istanbul ignore next: todo: test */
  private readonly cashierExpressWidgetOnShippingMethodSelected = async (shippingMethod: ShippingMethod) => {
    const {paymentAmount, paymentBreakdown} = await this.cashierExpressService.onShippingMethodSelected(shippingMethod);
    this.nextProps({
      cashierExpressWidgetOnShippingMethodSelectedResult: withChangeListener({paymentAmount, paymentBreakdown}),
    });
  };

  /* istanbul ignore next: todo: test */
  private readonly fetchPaymentBreakdownForCashierAddress = async (
    shippingAddress: ShippingContactRestricted
  ): Promise<void> => {
    const breakdown = await this.cashierExpressService.fetchPaymentBreakdownForCashierAddress(
      shippingAddress,
      this.translations
    );
    this.fetchPaymentBreakdownForCashierAddressResult = withChangeListener(breakdown);
    this.nextProps();
  };

  private readonly handleBuyNow = async (accessibilityEnabled: boolean): Promise<void> => {
    const shouldProceed = this.validateProductSubmission();
    if (!shouldProceed) {
      return;
    }

    this.fedopsLogger.interactionStarted(productPageFedopsEvent.BuyNow);

    /* istanbul ignore else: todo(ariel): test else */
    if (!this.directPurchaseService) {
      this.createDirectPurchaseService();
    }

    return this.directPurchaseService.handleBuyNow(
      accessibilityEnabled,
      this.product,
      this.userInputs,
      this.isPreOrderState()
    );
  };

  private readonly handleSubscribe = async (accessibilityEnabled: boolean): Promise<void> => {
    const shouldProceed = this.validateProductSubmission();
    if (!shouldProceed) {
      return;
    }

    this.fedopsLogger.interactionStarted(productPageFedopsEvent.Subscribe);

    /* istanbul ignore else: todo(ariel): test else */
    if (!this.directPurchaseService) {
      this.createDirectPurchaseService();
    }
    return this.directPurchaseService.handleSubscribe(accessibilityEnabled, this.product, this.userInputs);
  };

  private readonly handleAddToCart = async (): Promise<any> => {
    const validationObject = this.isInvalid(this.userInputs);
    const isNavigateCart = !this.styles.productPage_openMinicart || this.productService.shouldNavigateToCart();

    if (validationObject.isInvalid) {
      this.nextProps({
        isProductSubmitted: true,
        userInputErrors: validationObject.validations,
      });
      return;
    }
    this.setProps({addedToCartStatus: AddToCartActionStatus.IN_PROGRESS});

    this.fedopsLogger.interactionStarted(productPageFedopsEvent.AddToCart);

    const eventId = this.siteStore.pubSubManager.subscribe(
      'Minicart.DidClose',
      () => {
        this.setProps({
          // random so it will never be the same value
          shouldFocusAddToCartButton: Math.random(),
        });

        this.siteStore.pubSubManager.unsubscribe('Minicart.DidClose', eventId);
      },
      true
    );

    return this.productService.addToCart({
      product: this.product,
      userInputs: this.userInputs,
      addToCartAction: this.getAddToCartAction(),
      onSuccess: this.onAddToCartSuccess,
      selectedVariant: this.selectedVariant,
      navigation: {
        isNavigateCart,
        navigationClick: this.getAddToCartActionName(),
      },
      isPreOrderState: this.isPreOrderState(),
    });
  };

  private readonly onAddToCartSuccess = (): void => {
    this.fedopsLogger.interactionEnded(productPageFedopsEvent.AddToCart);
    this.fedopsLogger.flush();

    setTimeout(() => {
      //for helping screen readers. without timeout the focus will be on the button and not on the minicart/next element
      this.setProps({addedToCartStatus: AddToCartActionStatus.SUCCESSFUL});
    }, 1500);

    if (this.isQuickView) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.closeWixWindow();
    }
  };

  private readonly resetAddedToCartStatus = () => {
    this.setProps({addedToCartStatus: AddToCartActionStatus.IDLE});
  };

  private getHeaders() {
    return {
      Authorization: (this.siteStore.httpClient.getBaseHeaders() as any).Authorization,
    };
  }

  private readonly handleWishlistButtonClick = async () => {
    /* istanbul ignore next: todo test */
    if (!this.siteStore.usersApi.currentUser.loggedIn) {
      await this.siteStore.usersApi.promptLogin({});
    }

    const wishlistActionPromise = this.productAddedToWishlist
      ? new WishlistActions(this.getHeaders()).removeProducts([this.product.id])
      : new WishlistActions(this.getHeaders()).addProducts([this.product.id]);
    this.toggleWishlistState();
    this.reportWishlistFedops(true);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.reportWishlistBI();
    await wishlistActionPromise
      .then(() => {
        this.reportWishlistFedops(false);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.reportWishlistSuccessfulOperationBI();
      })
      .catch(() => {
        this.toggleWishlistState();
      });
  };

  private toggleWishlistState() {
    this.productAddedToWishlist = !this.productAddedToWishlist;
    this.setProps({
      productWasAddedToWishlist: this.productAddedToWishlist,
      wishlistActionStatus: ActionStatus.SUCCESSFUL,
    });
  }

  private readonly resetWishlistStatus = () => {
    this.setProps({
      wishlistActionStatus: ActionStatus.IDLE,
    });
  };

  private getAddToCartAction() {
    let addToCartAction = AddToCartActionOption.MINI_CART;
    if (this.styles.productPage_addToCartAction !== undefined) {
      addToCartAction = this.styles.productPage_addToCartAction;
    } else if (!this.styles.productPage_openMinicart) {
      addToCartAction = AddToCartActionOption.NONE;
    }
    return addToCartAction;
  }

  private readonly notifyCustomizeProduct = () => {
    return this.siteStore.windowApis.trackEvent(
      'CustomizeProduct' as ITrackEventName,
      {
        ...this.trackParams,
        variantId: this.selectedVariant?.id,
        optionsSelectionsIds: ProductService.mapOptionSelectionIds(this.userInputs),
        customTextFields: this.userInputs.text,
      } as ITrackEventParams
    );
  };

  private readonly notifyProductLoaded = () => {
    return this.siteStore.windowApis.trackEvent(
      'productPageLoaded' as any,
      {
        productId: this.product.id,
        name: this.product.name,
        currency: this.siteStore.currency,
        price: this.product.price,
        sku: this.product.sku,
      } as any
    );
  };

  private getAddToCartActionName(): string {
    if (!this.productService.shouldNavigateToCart() && this.getAddToCartAction() === AddToCartActionOption.TINY_CART) {
      return 'tiny-cart';
    } else if (
      !this.productService.shouldNavigateToCart() &&
      this.getAddToCartAction() === AddToCartActionOption.MINI_CART
    ) {
      return 'mini-cart';
    } else if (
      this.getAddToCartAction() === AddToCartActionOption.CART ||
      (this.productService.shouldNavigateToCart() && this.getAddToCartAction() !== AddToCartActionOption.NONE)
    ) {
      return 'cart';
    } else {
      return 'none';
    }
  }

  private reportButtonAction(buttonType: BiButtonActionType) {
    const eventData = {
      buttonType,
      appName: BI_APP_NAME,
      hasOptions: this.userInputs.selection.length > 0,
      productId: this.product.id,
      productType: this.product.productType as ProductType,
      origin: this.biOrigin,
      isNavigateCart: !this.styles.productPage_openMinicart || this.productService.shouldNavigateToCart(),
      navigationClick:
        buttonType === BiButtonActionType.BuyNow ||
        BiButtonActionType.PreOrderNow ||
        /* istanbul ignore next: todo: test */
        buttonType === BiButtonActionType.Subscribe
          ? 'checkout'
          : /* istanbul ignore next */
            this.getAddToCartActionName(),
      quantity: Math.round(this.selectedQuantity),
    };

    return this.siteStore.webBiLogger.report(clickOnAddToCartSf(eventData));
  }

  private reportWishlistBI() {
    const eventData = this.createWishlistBiEventData();

    return this.productAddedToWishlist
      ? this.siteStore.webBiLogger.report(clickAddToWishlistSf(eventData))
      : this.siteStore.webBiLogger.report(clickRemoveFromWishlistSf(eventData));
  }

  private reportWishlistSuccessfulOperationBI() {
    const eventData = this.createWishlistBiEventData();

    return this.productAddedToWishlist
      ? this.siteStore.webBiLogger.report(productAddedToWishlistSf(eventData))
      : this.siteStore.webBiLogger.report(productRemovedFromWishlistSf(eventData));
  }

  private createWishlistBiEventData() {
    return {
      appName: BI_APP_NAME,
      hasOptions: this.product.options.length > 0,
      productId: this.product.id,
      productType: this.product.productType as ProductType,
      origin: this.biOrigin,
    };
  }

  private reportWishlistFedops(isInteractionStarted: boolean) {
    const interactionName = this.productAddedToWishlist
      ? productPageFedopsEvent.AddToWishlist
      : productPageFedopsEvent.RemoveFromWishlist;
    return isInteractionStarted
      ? this.fedopsLogger.interactionStarted(interactionName)
      : this.fedopsLogger.interactionEnded(interactionName);
  }

  private get trackParams() {
    return {
      appDefId: APP_DEFINITION_ID,
      category: 'All Products',
      origin: 'Stores',
      id: this.product.id,
      name: this.product.name,
      price: actualPrice(this.product, this.selectedVariant),
      currency: this.siteStore.currency,
      quantity: this.selectedQuantity,
      sku: actualSku(this.product, this.selectedVariant),
      type: this.product.productType,
      brand: this.product.brand,
    };
  }

  /* istanbul ignore next: todo test */
  private trackViewContent() {
    return this.siteStore.windowApis.trackEvent(TrackEventName.VIEW_CONTENT, {
      ...this.trackParams,
      dimension3: this.product.isInStock ? 'in stock' : 'out of stock',
      quantity: undefined,
      variants: this.product.productItems.map((item) => ({
        id: item.id,
        optionsSelectionsIds: item.optionsSelections ?? [],
        price: item.price,
        sku: item.sku,
      })),
      options:
        this.product.options
          .map((option) => option.selections.map((selection) => ({id: selection.id, value: selection.value})))
          .flat() ?? [],
    } as ITrackEventParams);
  }

  private readonly isInvalid = (userInputs: UserInput): {isInvalid: boolean; validations: UserInputErrors} => {
    const validations = this.productService.validate(userInputs);

    const isInvalid = Object.keys(validations).reduce((accValidation: boolean, currentKey: string) => {
      const flag = validations[currentKey].some((value) => value === true);
      return accValidation || flag;
    }, false);

    return {isInvalid, validations};
  };

  private filterMedia(): void {
    const filteredMedia = _.flatMap(this.userInputs.selection, (item) => item?.linkedMediaItems || []);
    this.product.media = filteredMedia.length ? (filteredMedia as any) : this.media;
  }

  private getUrlWithoutParams(url: string): string {
    const parsedUrl = parseUrl(url);
    return `${parsedUrl.protocol}://${parsedUrl.host}${parsedUrl.path}`;
  }

  private async getCustomizedUrlSegments(): Promise<
    | {
        key: string;
        segments: {[key: string]: string};
      }
    | undefined
  > {
    const currentUrl = this.getUrlWithoutParams(this.siteStore.location.url);
    return this.siteStore.siteApis.getCustomizedUrlSegments(currentUrl);
  }

  private isDefaultProductPageUrl(currentUrl: string, defaultUrl: string): boolean {
    const currentUrlArr = currentUrl.split('/');
    currentUrlArr.pop();
    const currentUrlWithoutLatPart = currentUrlArr.join('/');
    return currentUrlWithoutLatPart === defaultUrl;
  }

  private shouldGetBySlug(): boolean {
    const currentUrl = this.getUrlWithoutParams(this.siteStore.location.url);

    if (this.siteStore.experiments.enabled(SPECS.LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE)) {
      this.currentPath = this.siteStore.location.path;
    }

    if (
      ((this.siteStore.isEditorMode() || this.siteStore.isPreviewMode()) && this.currentPath.length > 1) ||
      this.siteStore.isSiteMode()
    ) {
      if (this.isUrlWithOverrides && !this.isQuickView) {
        return !_.isEmpty(this.urlOverrideSegments) || this.isDefaultProductPageUrl(currentUrl, this.sectionUrl);
      } else {
        return currentUrl !== this.sectionUrl;
      }
    } else {
      return false;
    }
  }

  private isDefaultInSEO(): boolean {
    const currentUrl = this.getUrlWithoutParams(this.siteStore.location.url);

    /* istanbul ignore next: todo test */
    if (this.siteStore.isSiteMode() && this.siteStore.seo.isInSEO()) {
      if (this.isUrlWithOverrides && !this.isQuickView) {
        return _.isEmpty(this.urlOverrideSegments);
      } else {
        return currentUrl === this.sectionUrl;
      }
    } else {
      return false;
    }
  }

  private async getInitialData(): Promise<{
    product: IProductDTO;
    appSettings: IAppSettings;
    siteSettingsCurrencies: ISiteSettingsCurrencies;
  }> {
    const shouldGetBySlug = this.shouldGetBySlug();
    /* istanbul ignore next: todo test */
    if (this.isDefaultInSEO()) {
      return {product: null, appSettings: {}, siteSettingsCurrencies: {checkoutCurrencies: []}};
    }

    const withCheckoutCurrencies = this.siteStore.getCurrentCurrency() !== this.siteStore.currency;

    let catalog: GetProductBySlugQuery['catalog'] | GetFirstProductQuery['catalog'],
      appSettings: GetProductBySlugQuery['appSettings'],
      siteSettingsCurrencies: GetProductBySlugLargeQuery['siteSettingsCurrencies'];
    const key = `productPage_${this.siteStore.getCurrentCurrency()}_${shouldGetBySlug ? this.slug : 'default'}`;
    if (this.siteStore.windowApis.warmupData.get(key)) {
      ({catalog, appSettings} = this.siteStore.windowApis.warmupData.get(key));
    } else {
      ({catalog, appSettings, siteSettingsCurrencies} = await (shouldGetBySlug
        ? this.productService.getProductBySlug(this.slug, this.externalId, withCheckoutCurrencies)
        : this.productService.getDefaultProduct(this.externalId, withCheckoutCurrencies)));
      this.siteStore.windowApis.warmupData.set(key, {catalog, appSettings, siteSettingsCurrencies});
    }

    return {
      appSettings,
      product: shouldGetBySlug ? (catalog as any).product : (catalog as any).products.list[0],
      siteSettingsCurrencies,
    };
  }

  private getPrevNextProducts(): ProductPagePagination {
    return new NavigationService(
      this.siteStore,
      this.sectionUrl,
      this.navigationContext,
      this.product,
      this.customUrlApi,
      this.isUrlWithOverrides
    ).getPrevNextProducts();
  }

  private get getDirtySlug(): string {
    const {path} = this.siteStore.location;
    /* istanbul ignore next: todo test */
    if (path.length === 1) {
      throw new Error(`invalid slug path: "${path.toString()}"`);
    }
    const dirtySlug = decodeURIComponent(path[path.length - 1]);
    return dirtySlug.split('?')[0];
  }

  /* istanbul ignore next: todo test */
  private get slug() {
    if (!this.isQuickView && this.isUrlWithOverrides && !this.siteStore.experiments.enabled(SPECS.USE_LIGHTBOXES)) {
      return _.get(this.urlOverrideSegments, 'segments.slug') || this.getDirtySlug;
    } else if (this.siteStore.windowApis.lightbox.getContext()?.productSlug) {
      return this.siteStore.windowApis.lightbox.getContext().productSlug;
    }

    return this.getDirtySlug;
  }

  private get remainingItemCount(): StockIndicatorCount {
    const itemCount = this.quantityRange.max;
    const threshold = 10;

    if (itemCount > 0 && itemCount < threshold) {
      return itemCount;
    }

    const productInStock = inStock(this.product, this.selectedVariant);
    if (!productInStock && this.backInStockStore.isBackInStockEnabled) {
      return 0;
    }

    return null;
  }

  private get quantityRange(): ProdudctQunatityRange {
    const qunatities = QuantityCalculator.getQuantitiesRange(
      this.product,
      this.userInputs.selection as IProductOptionSelection[],
      this.siteStore.experiments.enabled(SPECS.SHOULD_USE_VARIANT_LEVEL_PRE_ORDER_AVAILABLE)
    );
    return {max: qunatities[qunatities.length - 1], min: qunatities[0]};
  }

  private get selectedQuantity(): number {
    return this.userInputs.quantity[0];
  }

  private readonly setPageMetaData = (): void => {
    if (!this.siteStore.isSiteMode()) {
      return;
    }

    let seoData;

    try {
      seoData = JSON.parse((this.product as any).seoJson);
    } catch {
      //
    }

    const productWithPageUrl = {...this.product, pageUrl: this.productUrl};
    const itemData: ProductPageItemData = {
      product: new SeoProductBuilder(
        productWithPageUrl,
        {
          productPageBaseUrl: this.getUrlWithoutParams(this.siteStore.location.url),
        },
        this.siteStore.experiments.enabled(SPECS.PRODUCT_PAGE_RICO_DESCRIPTION)
      ).get(),
      legacySeoData: {
        title: this.product.seoTitle,
        description: this.product.seoDescription,
      },
    };

    this.siteStore.seo.renderSEOTags({
      itemType: 'STORES_PRODUCT',
      itemData,
      seoData,
    });
  };

  private getNavigationContext(): IStoreFrontNavigationContext {
    return new NavigationContextService({siteStore: this.siteStore}).navigationContext;
  }

  private get productUrl(): string {
    return this.isUrlWithOverrides
      ? this.customUrlApi.buildProductPageUrl({slug: this.product.urlPart})
      : `${this.sectionUrl}/${this.product.urlPart}`;
  }

  private get isQuickView(): boolean {
    const byLayout = this.styles.productPage_layoutId === LayoutId.QuickView;
    const byQuery = this.getQueryParam('layout') === 'quickview';

    return byLayout || byQuery;
  }

  public getSelectionById(id: number) {
    let selection = null;
    // eslint-disable-next-line
    this.product.options.some((option) => {
      selection = option.selections.find((item) => item.id === id);
      return selection;
    });
    return selection;
  }

  public get passedSelections(): IProductOptionSelection[] {
    let selectionIds = [];
    const variantId = this.getQueryParam('variantId');
    const rawSelectionIds = this.getQueryParam('selectionIds');

    if (variantId) {
      const productItem = this.product.productItems.find(({id}) => id === variantId);
      selectionIds = productItem.optionsSelections;
    } else if (rawSelectionIds) {
      selectionIds = decodeURIComponent(rawSelectionIds)
        .split(',')
        .map((id) => parseInt(id, 10));
    }

    return selectionIds.map((id) => this.getSelectionById(id));
  }

  public get passedQuantity(): number {
    return parseInt(this.getQueryParam('quantity') || '1', 10);
  }

  private getQueryParam(key: string): string | undefined {
    /* istanbul ignore else  */
    if (typeof location !== 'undefined') {
      const valueFromLocation = new URLSearchParams(location.search).get(key);

      if (valueFromLocation) {
        return valueFromLocation;
      }
    }

    return this.siteStore.location.query[key];
  }

  private get shouldUseCommonDiscountPricingMethods(): boolean {
    return this.siteStore.experiments.enabled(SPECS.SHOULD_USE_COMMON_DISCOUNT_PRICING_METHODS);
  }

  /* istanbul ignore next */
  public reportBI = (event: ReportProps): void => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.siteStore.webBiLogger.report(event);
  };

  private get biOrigin(): string {
    return this.isQuickView ? Origin.QUICK_VIEW : Origin.PRODUCT_PAGE;
  }

  private get layoutId(): LayoutId {
    return this.isQuickView ? LayoutId.QuickView : this.styles.productPage_layoutId;
  }

  private get selectedVariant() {
    return this.productService.options.selectedVariant;
  }

  private get addToCartState(): AddToCartState {
    return this.addToCartService.getButtonState({
      price: actualPrice(this.product, this.selectedVariant),
      inStock: inStock(this.product, this.selectedVariant),
      isPreOrderState: this.isPreOrderState(),
    });
  }

  private handleEmptyState() {
    this.siteStore.seo.setSeoStatusCode(404);
    this.setProps({
      ...this.defaultProps,
      product: null,
      layoutId: LayoutId.EmptyState,
    });

    if (this.siteStore.isSSR()) {
      this.fedopsLogger.appLoaded();
    }
  }

  private get selectedPlan() {
    return this.userInputs.subscriptionPlan[0];
  }

  private get currentPrice(): CurrentPrice {
    return new ProductPriceService({
      product: this.product,
      selectedVariant: this.selectedVariant,
      selectedPlan: this.selectedPlan,
      shouldRenderPriceRange: this.shouldRenderPriceRange,
      shouldUseCommonDiscountPricingMethods: this.shouldUseCommonDiscountPricingMethods,
      shouldUseProductLevelPricePerUnit: this.siteStore.experiments.enabled(SPECS.ShouldUseProductLevelPricePerUnit),
    }).getCurrentPricing(this.userInputs);
  }

  private sendClickOnProductOptionBiEvent(
    selectionItem: IProductOptionSelectionItem,
    prevSelectionItem: IProductOptionSelectionItem
  ) {
    const action = selectionItem ? BI_PRODUCT_OPTION_ACTION.CHECKED : BI_PRODUCT_OPTION_ACTION.UNCHECKED;

    const selectionId = selectionItem?.id ?? prevSelectionItem.id;

    const optionType = this.product.options.find(({selections}) =>
      selections.map(({id}) => id).includes(selectionId)
    ).optionType;

    const optiontype = (
      {
        [ProductOptionType.DROP_DOWN]: BI_PRODUCT_OPTION_TYPE.LIST,
        [ProductOptionType.COLOR]: BI_PRODUCT_OPTION_TYPE.COLOR,
      } as const
    )[optionType];

    const {productType} = this.product;

    const isVariantInStock = inStock(this.product, this.productService.options.selectedVariant);

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.siteStore.webBiLogger.report(
      clickOnProductOptionSf({
        action,
        appName: BI_APP_NAME,
        productId: this.product.id,
        optiontype,
        productType,
        origin: this.biOrigin,
        viewMode: this.siteStore.biStorefrontViewMode,
        inStock: isVariantInStock,
        hasNotifyMe: this.backInStockStore.isBackInStockEnabled,
        hasStockIndicator: this.styles.productPage_stockIndicator,

        remainingItemCount: this.remainingItemCount > 0 ? this.remainingItemCount : undefined,
      })
    );
  }

  private get shouldShowProductPaymentBreakdown() {
    return (
      !this.siteStore.location.baseUrl.includes('//localhost') &&
      this.subscriptionService.isBreakableToPaymentOptions(this.userInputs) &&
      this.styles.productPage_paymentOptionsBreakdown
    );
  }

  private get shouldShowDiscountName(): boolean {
    const shouldShowDiscountNameStyleParam = this.styles.productPage_showDiscountName;
    const isDiscountNameExist = Boolean(this.product.itemDiscount?.discountRuleName);
    return shouldShowDiscountNameStyleParam && isDiscountNameExist;
  }

  private get breakdownParams(): IBreakdownParams & {LazySentry: null} {
    const {productPage_paymentOptionsBreakdownTheme} = this.styles;
    /* istanbul ignore next */
    return {
      meta: {
        appDefId: APP_DEFINITION_ID,
        appInstanceId: this.siteStore.storeId,
        appInstance: this.siteStore.instanceManager.getInstance(),
        productId: this.product.id,
        msid: this.siteStore.storeId,
        host: this.siteStore.location.baseUrl,
        visitorId: this.siteStore.uuid as string,
      },
      amount: String(actualPrice(this.product, this.selectedVariant) * this.selectedQuantity),
      currency: this.siteStore.getCurrentCurrency(),
      deviceType: this.siteStore.isMobile() ? 'mobile' : 'desktop',
      isSSR: this.siteStore.isSSR(),
      locale: this.siteStore.locale,
      LazySentry: null, // passed from host.LazySentry in viewer,
      theme:
        productPage_paymentOptionsBreakdownTheme === PaymentOptionsBreakdownTheme.DARK
          ? PaymentOptionsBreakdownThemeValue.DARK
          : PaymentOptionsBreakdownThemeValue.LIGHT,
    };
  }

  private get variantInfo() {
    return {
      selectionsAvailability: calcSelectionsAvailability({
        product: this.product,
        variantSelectionIds: this.userInputs[UserInputType.Selection].filter(Boolean).map(({id}) => id),
      }),
    };
  }

  private getHtmlTags() {
    const defaultInfoSectionTitleHtmlTag =
      this.styles.productPage_infoSectionTypeId === InfoSectionLayoutId.Tabs ? HeadingTags.P : HeadingTags.H2;
    return {
      infoSectionTitleHtmlTag:
        this.mergedPublicData.productPage_infoSectionTitleHtmlTag || defaultInfoSectionTitleHtmlTag,
    };
  }

  private get shouldShowUserInputs(): boolean {
    return this.backInStockStore.isBackInStockEnabled || inStock(this.product) || this.isPreOrderState();
  }

  private get biProductInventoryStatus(): BiInventoryStatus {
    const isInStock = inStock(this.product);

    const hasVariantOutOfStock = (this.product as IProduct).productItems.some(
      (item) => !inStock(this.product, item as IOptionSelectionVariant)
    );

    if (!isInStock) {
      return BiInventoryStatus.OUT_OF_STOCK;
    }

    return hasVariantOutOfStock ? BiInventoryStatus.PARTIALLY : BiInventoryStatus.IN_STOCK;
  }
}
